import {Directive, Injector, Input, OnChanges, OnInit, Type, ViewContainerRef} from '@angular/core';
import {BehaviorSubject, NEVER, Observable} from 'rxjs';
import {distinctUntilChanged, switchMap, takeUntil} from 'rxjs/operators';
import {TypedSimpleChanges} from '../../../common/typed-on-changes';
import {destroy$} from '../../destroyable';
import {DynamicComponentFactoryService} from '../../dynamic-component';

@Directive({
    selector: '[mainMenuDropdownCustomItemRenderer]',
    standalone: true
})
export class MainMenuDropdownCustomItemRendererDirective implements OnChanges, OnInit {

    @Input('mainMenuDropdownCustomItemRenderer')
    public component: Type<any>;

    public readonly destroy$ = destroy$();

    private readonly component$ = new BehaviorSubject<Type<any>>(null);

    constructor(
        private dynamicComponentFactoryService: DynamicComponentFactoryService,
        private viewContainerRef: ViewContainerRef,
        private injector: Injector
    ) {}

    public ngOnChanges(changes: TypedSimpleChanges<MainMenuDropdownCustomItemRendererDirective>): void {
        if (changes.component) {
            this.component$.next(this.component);
        }
    }

    public ngOnInit(): void {
        this.listenToComponent().pipe(
            takeUntil(this.destroy$)
        ).subscribe();
    }

    private listenToComponent(): Observable<any> {
        return this.component$.pipe(
            distinctUntilChanged(),
            switchMap(component => component
                ? this.renderComponent(component)
                : NEVER
            )
        );
    }

    private renderComponent(component: Type<any>): Observable<any> {
        return new Observable(() => {
            const componentRef = this.dynamicComponentFactoryService.create(component, {
                injector: this.injector,
                place: {
                    viewContainerRef: this.viewContainerRef
                }
            });

            return () => componentRef.destroy();
        });
    }

}
